import { Outlet } from "react-router";

import Dashboard from "legacy/containers/Dashboard";

const LegacyDashboardLayout = () => (
  <Dashboard>
    <Outlet />
  </Dashboard>
);

export { LegacyDashboardLayout };
